import React from "react";
import styles from "./styles.module.scss";
import Logo from "../../../../assets/images/logo.png";

export const DisableScreen: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <img className={styles.logo} src={Logo} alt="logo" />
      <div>
        <p className={styles.title}>O período do jogo já acabou 😢</p>
        <p className={styles.subtitle}>
          Fique de olho na{" "}
          <a
            href="https://www.instagram.com/leiturinha/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>@leiturinha</strong>
          </a>{" "}
          para futuras ações! Obrigado por jogar conosco! 😉
        </p>
      </div>
    </div>
  );
};
